import React from 'react';
import { Plus, Bell } from 'lucide-react';

const NotificationPageHeader = ({ activeTab, onCreateClick }) => {
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
            <Bell className="w-8 h-8 text-[#FF6B00]" />
            Gestion des Notifications
          </h1>
          <p className="text-gray-600 mt-2">
            Envoyez des notifications ciblées à vos utilisateurs
          </p>
        </div>
        <button
          onClick={onCreateClick}
          className="flex items-center gap-2 px-6 py-3 bg-[#FF6B00] text-white rounded-lg hover:bg-[#e55d00] transition-colors font-medium shadow-lg"
        >
          <Plus className="w-5 h-5" />
          {activeTab === 'notifications' ? 'Nouvelle notification' : 'Nouveau modèle'}
        </button>
      </div>
    </div>
  );
};

export default NotificationPageHeader;
